import React, { useState } from 'react';

function WelcomeAdminModal({ isOpen, onClose, onOpenOperatorsModal }) {
    const [isHovered, setIsHovered] = useState(false);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-content" style={{
                    maxWidth: '500px',
                    padding: '30px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    borderRadius: '12px',
                    position: 'relative'
                }}>
                    {/* Botón de cierre (cruz) en la esquina superior derecha */}
                    <button
                        className="close-button"
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            background: 'none',
                            border: 'none',
                            fontSize: '28px',
                            cursor: 'pointer',
                            color: '#64748b',
                            padding: '0',
                            lineHeight: '1',
                            fontWeight: 'bold'
                        }}
                    >
                        ×
                    </button>

                    <h2 style={{
                        fontSize: '32px',
                        marginBottom: '30px',
                        color: 'rgb(102, 102, 102)',
                        textAlign: 'center',
                        fontWeight: '500',
                        marginTop: '20px'
                    }}>¡Bienvenido a TransferisOK!</h2>

                    <div style={{
                        padding: '20px',
                        marginBottom: '40px',
                        textAlign: 'center',
                        fontSize: '22px',
                        lineHeight: '1.6'
                    }}>
                        <p>Para comenzar, creá operadores para darles acceso a verificar las transferencias recibidas.</p>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '20px'
                    }}>
                        <button
                            style={{
                                backgroundColor: isHovered ? '#00143a' : '#001c4d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                width: '100%',
                                height: '48px',
                                maxWidth: '400px'
                            }}
                            onClick={() => {
                                onClose();
                                onOpenOperatorsModal();
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            Ir a Operadores
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WelcomeAdminModal; 